import * as React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { RouteComponentProps } from 'react-router';
import { logUI } from "../../api/andyliticsApi";
import ModuleCrash from "../common/ModuleCrash";
import * as Tools from "../../helpers/Tools";

export class OurRoute extends Route {
    static getDerivedStateFromError(error) {
        //debugger;
        return { hasError: true };
    }

    constructor(props, context) {
        //debugger;
        super(props, context);
        //debugger;
        this.state = {
            ...(this.state ? this.state : {}),
            hasError: false
        };
        //debugger;
    //    //debugger;
        //this.setState({ hasError: false });
        //this.state = { hasError: false };
        this.shouldHideBanner = this.shouldHideBanner.bind(this);
    }

    componentDidMount() {

        //  debugger;
    }

    componentDidUpdate(prevProps, prevState) {
        const { hasError } = this.state;
        //debugger;
        if (this.props.location.pathname !== prevProps.location.pathname) {
            if (hasError) {
                this.setState({ hasError: false });
            }
        }
        if (hasError && prevState.hasError === undefined)
            this.shouldHideBanner(true);
        else if (hasError === undefined && prevState.hasError)
            this.shouldHideBanner(false);
    }

    componentWillUnmount() {
        //debugger;
        const { hasError } = this.state;
        if (hasError) {
            this.setState({ hasError: false });
        }
    }

    componentDidCatch(error, info) {
        //debugger;
        console.error({ error, info });
        this.setState({ hasError: true });
        let json = { error: error, componentStack: info };
        //logUI("MBHWeb.Event.OurRoute.Exception", new Date(), null, JSON.stringify(json));
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(error), JSON.stringify(info));
    }

    shouldHideBanner = (flag) => {
        if (this.props.hideBannerOnCrash)
            this.props.hideBannerOnCrash(flag);
    }

    render() {
        if (this.state.match) {
            if (typeof window !== 'undefined') {
                if (this.props.title) {
                    if (window.document.title !== this.props.title) {
                        window.document.title = this.props.title;
                    }
                }
            }
        }
        if (this.state.hasError) {
            //console.info(`OurRoute has error '${this.state.hasError}'`);
            return <ModuleCrash />;
        }
        else {
            //console.info(`OurRoute END of our stuff calling react-router-rout render`);
            return (
                super.render()
            );
        }
    }

}

